import { useState } from "react";
import { Alert, Button, Form, Offcanvas, Spinner } from "react-bootstrap";

import {
  FixedToolbarItem,
  GridForm,
  GridFormItemWrapper,
  Toolbar,
  useToastManager,
} from "@bagel-web/components";

export type CommonNewAPIKey = {
  notes: string;
};

const NewAPIKeyDrawer = ({
  show,
  onClose,
  onSave,
}: {
  show: boolean;
  onClose: () => void;
  onSave: (apiKey: CommonNewAPIKey) => Promise<unknown>;
}) => {
  const { publishToast } = useToastManager();
  const [notes, setNotes] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const trimmedNotes = notes.trim();

  const resetDrawerState = () => {
    setNotes("");
    setErrorMessage("");
  };

  const handleCancel = () => {
    resetDrawerState();
    onClose();
  };

  const handleSave = async (event?: React.SyntheticEvent) => {
    event?.preventDefault();
    try {
      setIsSaving(true);
      await onSave({ notes: trimmedNotes });
      publishToast("API key created");
      resetDrawerState();
      onClose();
    } catch (error) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("Unknown error");
      }
    } finally {
      setIsSaving(false);
    }
  };

  const saveDisabled = isSaving || trimmedNotes === "";

  return (
    <Offcanvas show={show} placement="end" onHide={handleCancel}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>New API Key</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        <GridForm $numCols={1} $width="100%" onSubmit={handleSave}>
          <GridFormItemWrapper>
            <Form.Label>Name</Form.Label>
            <Form.Control
              autoComplete="off"
              autoFocus={true}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Name"
            />
          </GridFormItemWrapper>
        </GridForm>
        <Toolbar className="mt-3" style={{ justifyContent: "end" }}>
          <FixedToolbarItem>
            <Button
              variant="primary"
              disabled={saveDisabled}
              onClick={handleSave}
            >
              {isSaving ? <Spinner size="sm" /> : "Save"}
            </Button>
          </FixedToolbarItem>
        </Toolbar>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default NewAPIKeyDrawer;
